import { materialPath } from "./binary.js";
import { logger } from "./log.js";
const log = logger("Material");
export function keyValues(text) {
    const tokens =
        text.match(/"(?:\\.|[^"\\])*"|\/\/[^\n]*|[{}]|[^\s{}"]+/g) ?? [];
    const clean = tokens.filter((t) => !t.startsWith("//"));
    let pos = 0,
        count = 0;
    const value = (t) =>
        t?.startsWith('"') ? t.slice(1, -1).replace(/\\"/g, '"') : t;
    function object(depth, proxies = false) {
        if (depth > 32) throw new Error("KeyValues nesting limit");
        const result = Object.create(null);
        if (proxies) result.$sequence = [];
        while (pos < clean.length && clean[pos] !== "}") {
            if (++count > 100000) throw new Error("KeyValues size limit");
            const key = value(clean[pos++]).toLowerCase(),
                token = clean[pos++];
            if (!token) throw new Error("Incomplete KeyValues");
            if (token === "{") {
                result[key] = object(depth + 1, key === "proxies");
                if (clean[pos++] !== "}") throw new Error("Unclosed KeyValues");
            } else result[key] = value(token);
            if (proxies) result.$sequence.push({ type: key, values: result[key] });
        }
        return result;
    }
    return object(0);
}
export async function readMaterial(path, load, chain = []) {
    path = materialPath(path);
    log.debug("read", { path, includeDepth: chain.length });
    if (chain.length >= 16 || chain.includes(path))
        throw new Error("Cyclic VMT include");
    const root = keyValues(new TextDecoder().decode(await load(path))),
        shader = Object.keys(root)[0];
    if (!shader || typeof root[shader] !== "object")
        throw new Error("Invalid VMT");
    const values = root[shader];
    if (shader !== "patch") {
        log.debug("parsed", { path, shader });
        return { shader, values: { ...values, ...values[">=dx90"], ...values[`${shader}_dx9`], ...values[`${shader}_dx90`] } };
    }
    if (!values.include) throw new Error("VMT patch missing include");
    const base = await readMaterial(values.include, load, [...chain, path]);
    log.debug("patch resolved", { path, include: values.include, shader: base.shader });
    const result = { ...base.values };
    const merge = (target, patch, replace) => {
        for (const [key, value] of Object.entries(patch ?? {})) {
            if (key === "$sequence" && value.length === 0) continue;
            if (value && typeof value === "object" && !Array.isArray(value) &&
                target[key] && typeof target[key] === "object")
                target[key] = merge({ ...target[key] }, value, replace);
            else if (replace === (key in target)) target[key] = value;
        }
        return target;
    };
    merge(result, values.insert, false);
    merge(result, values.replace, true);
    return { shader: base.shader, values: result };
}
export function entities(text) {
    const blocks = text.match(/\{[^}]*\}/g) ?? [];
    return blocks.map((b) => keyValues(b.slice(1, -1)));
}
